import React from 'react';
import { Box, Typography } from '@mui/material';

const IMPACT_CONFIG = {
  alto: { label: 'Alto impacto', dot: '#C62828', bg: '#FFEBEE', text: '#C62828' },
  medio: { label: 'Impacto medio', dot: '#7D5A00', bg: '#FFF8E1', text: '#7D5A00' },
  basico: { label: 'Impacto básico', dot: '#2E7D32', bg: '#E8F5E9', text: '#2E7D32' },
};

const ImpactBadge = ({ impact, size = 'small' }) => {
  const cfg = IMPACT_CONFIG[impact];
  if (!cfg) return null;

  const isSmall = size === 'small';

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: isSmall ? 0.5 : 0.75,
        bgcolor: cfg.bg,
        borderRadius: '999px',
        px: isSmall ? 1 : 1.5,
        py: isSmall ? 0.25 : 0.5,
      }}
    >
      <Box
        sx={{
          width: isSmall ? 6 : 8,
          height: isSmall ? 6 : 8,
          borderRadius: '50%',
          bgcolor: cfg.dot,
          flexShrink: 0,
        }}
      />
      <Typography
        sx={{
          fontSize: isSmall ? '12px' : '12px',
          fontWeight: 600,
          color: cfg.text,
          lineHeight: 1,
          whiteSpace: 'nowrap',
        }}
      >
        {cfg.label}
      </Typography>
    </Box>
  );
};

export default ImpactBadge;
